// extracted by mini-css-extract-plugin
module.exports = {"form":"TicketMessageForm_form__2djpP","input":"TicketMessageForm_input__2BFmW","actions":"TicketMessageForm_actions__1DUJE"};